<div class="px-4">
  <div class="d-flex justify-content-between pt-1 my-1">
    <form
      [formGroup]="filterForm"
      class="mat-form d-flex align-items-center gap-10">
      <app-input-template
        (keyup)="applyFilter()"
        [inputData]="attrConstant.search"
        [formControlName]="attrConstant.search.key"></app-input-template>
      <img
        src="assets/images/clear-filter.svg"
        class="clear-img"
        alt="clear-filter"
        matTooltip="Clear Filters"
        matTooltipPosition="above"
        [attr.aria-hidden]="true"
        (click)="clearFilters()" />
    </form>
    <div class="d-flex align-items-center gap-10">
      <img
        src="assets/images/reload.svg"
        alt="reload"
        class="reload-img"
        matTooltip="Reload"
        matTooltipPosition="above"
        [attr.aria-hidden]="true"
        (click)="reload()" />
      <button class="btn primary-btn" (click)="export()">Export</button>
    </div>
  </div>
  <table
    mat-table
    matSort
    [matSortActive]="activeSort?.active ?? 'created_at'"
    [matSortDirection]="activeSort?.direction ?? 'desc'"
    [dataSource]="dataSource"
    (matSortChange)="onSortChange($event)">
    <!-- Countries Column -->
    <ng-container matColumnDef="countries">
      <th mat-header-cell *matHeaderCellDef>Countries</th>
      <td mat-cell *matCellDef="let element" data-label="Countries">
        <!-- Source country leads the cell: several corridors share one currency
             pair, so the pair alone makes distinct rows look like duplicates. -->
        <span class="d-inline-flex align-items-center gap-2">
          <img
            height="20"
            alt="source-country"
            src="assets/images/country-square/{{ element.source_country }}.png"
            onerror="this.style.display='none'" />
          <span>{{ element.source_country }}</span>
          <span>&middot;</span>
          <span>
            {{ element.source_currency }} - {{ element.destination_currency }}
          </span>
        </span>
      </td>
    </ng-container>

    <!-- Transfer Type Column -->
    <ng-container matColumnDef="transfer_type_po_name">
      <th mat-header-cell *matHeaderCellDef>Transfer Type</th>
      <td mat-cell *matCellDef="let element" data-label="Transfer Type">
        {{ element.transfer_type_po_name }}
      </td>
    </ng-container>

    <!-- Service Level Column -->
    <ng-container matColumnDef="service_level_name">
      <th mat-header-cell *matHeaderCellDef>Service Level</th>
      <td mat-cell *matCellDef="let element" data-label="Service Level">
        {{ element.service_level_name }}
      </td>
    </ng-container>

    <!-- Payment Type Column -->
    <ng-container matColumnDef="payment_type_name">
      <th mat-header-cell *matHeaderCellDef>Payment Type</th>
      <td mat-cell *matCellDef="let element" data-label="Payment Type">
        {{ element.payment_type_name }}
      </td>
    </ng-container>

    <!-- Our Fee Column -->
    <ng-container matColumnDef="other_fee">
      <th mat-header-cell *matHeaderCellDef>Our Fee</th>
      <td mat-cell *matCellDef="let element" data-label="Our Fee">
        {{ element.other_fee }}
      </td>
    </ng-container>

    <!-- Mark Up(%) Column -->
    <ng-container matColumnDef="markup_percentage">
      <th mat-header-cell *matHeaderCellDef>Mark Up(%)</th>
      <td mat-cell *matCellDef="let element" data-label="Mark Up(%)">
        {{ element.markup_percentage }}
      </td>
    </ng-container>

    <!-- Master Rate Column -->
    <ng-container matColumnDef="master_rate">
      <th mat-header-cell *matHeaderCellDef>Master Rate</th>
      <td mat-cell *matCellDef="let element" data-label="Master Rate">
        {{ element.master_rate }}
      </td>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <ng-container *appHasAccess="'/settings/edit-conversion-rate'">
          Action
        </ng-container>
      </th>
      <td mat-cell *matCellDef="let element" data-label="Action">
        <div class="d-flex align-items-center action-gap-10">
          <img
            src="assets/images/edit-icon.svg"
            alt=""
            matTooltip="Edit"
            matTooltipPosition="left"
            [attr.aria-hidden]="true"
            (click)="onEdit(element)"
            *appHasAccess="'/settings/edit-conversion-rate'" />
          <img
            src="assets/images/delete-icon.svg"
            alt=""
            matTooltip="Delete"
            matTooltipPosition="right"
            [attr.aria-hidden]="true"
            (click)="onDeleteConversionRate(element)"
            *appHasAccess="'delete-conversion-rate'" />
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      class="custom-mat-btn"
      *matRowDef="let row; columns: displayedColumns; let element"></tr>
  </table>
  <mat-paginator
    showFirstLastButtons
    [pageIndex]="page"
    [length]="total"
    [pageSize]="limit"
    [pageSizeOptions]="[10, 20, 50, 100, 200]"
    (page)="onPageChange($event)"></mat-paginator>
</div>
